import { render, staticRenderFns } from "./LandingBouteilles.vue?vue&type=template&id=363c27c2&scoped=true"
import script from "./LandingBouteilles.vue?vue&type=script&lang=js"
export * from "./LandingBouteilles.vue?vue&type=script&lang=js"
import style0 from "./LandingBouteilles.vue?vue&type=style&index=0&id=363c27c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c27c2",
  null
  
)

export default component.exports